import { useTranslation } from 'react-i18next';
import isNil from 'lodash/isNil';

import { LabelValueContainer } from './LabelValue.styles';
import { useValueByConnectivity } from '@/hooks/useValueByConnectivity';
import { DeviceConnectivity } from '@/constants/enums';

export interface LabelValueItem {
  label?: string;
  value: string | number;
  unit?: string | React.ReactNode;
  prefix?: string;
  suffix?: string;
  isLarge?: boolean;
  connectivity?: DeviceConnectivity;
  displayValueByConnectivity?: boolean;
}

const LabelValue = ({
  label,
  value,
  unit,
  prefix,
  suffix,
  isLarge,
  connectivity,
  displayValueByConnectivity,
}: LabelValueItem) => {
  const { t } = useTranslation();
  const { tcvalue, tcunit } = useValueByConnectivity();

  let displayValue = value;
  let displayUnit = unit;
  if (displayValueByConnectivity) {
    displayValue = tcvalue(value, connectivity);
    displayUnit = tcunit(unit, value, connectivity);
  }

  if (displayValue === 'N/A' || displayValue === "_ _") return null;

  return (
    <LabelValueContainer $isLarge={isLarge}>
      <div className="label">{label ? t(label) : '\u00A0'}</div>
      <div>
        {prefix && <span className="prefix">{prefix}</span>}
        <span className="value">{displayValue ?? t('N/A')}</span>
        {!isNil(displayValue) && displayUnit && <span className="unit">{displayUnit}</span>}
        {!!suffix && <span className="unit">{suffix}</span>}
      </div>
    </LabelValueContainer>
  );
};

export default LabelValue;
